"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbUser = exports.user = exports.userID = void 0;
const typebox_1 = require("@sinclair/typebox");
const personalInfo_1 = require("./personalInfo");
const string_1 = require("../options/string");
/**
 * Unique identifier type used to look up users when using path parameters.
 */
exports.userID = typebox_1.Type.Object({
    userID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of a user' })),
});
/**
 * Extends the personal information of a user with a unique ID and some
 * relevant info for the Frontend, such as the last login timestamp.
 */
exports.user = typebox_1.Type.Intersect([
    personalInfo_1.personalInfo,
    typebox_1.Type.Object({
        ID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of the user' })),
        registerDateTime: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'timestamp of profile creation' })),
        lastLoginDateTime: typebox_1.Type.Union([
            typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'last login' })),
            typebox_1.Type.Null({
                description: 'user has not logged in yet',
            }),
        ], {
            description: 'timestamp of last login',
            example: null,
        }),
    }),
]);
/**
 * Further extends {@link user} to make it have all fields that are stored in the user
 * table in the database. The Server uses the password hash data to verify authenticity,
 * and the confirmation code and code creation time for password reset support.
 */
exports.dbUser = typebox_1.Type.Intersect([
    exports.user,
    typebox_1.Type.Object({
        passwordHash: typebox_1.Type.String({
            description: 'argon2 password hash',
            minLength: 95,
            maxLength: 95,
        }),
        confirmationCode: personalInfo_1.confirmationCode,
        confirmationCodeCreateDateTime: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.dateTime), { description: 'timestamp of confirmation code creation' })),
    }),
]);
//# sourceMappingURL=user.js.map